import { createRouter, createWebHistory } from 'vue-router';

import Home from './pages/Home.vue';
import Contact from './pages/Contact.vue';
import Portfolio from './pages/Portfolio.vue';
import Strength from './pages/Strength.vue';
import About from './pages/About.vue';
import NotFound from './pages/NotFound'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {path: '', redirect: '/home'},
        { path: '/home', component: Home },
        { path: '/contact', component: Contact },
        { path: '/portfolio', component: Portfolio },
        { path: '/about', component: About },
        { path: '/strength', component: Strength },
        { path: '/:notFound(.*)', component: NotFound}
    ],
});

export default router;